/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Bodyfat_FirstInputs */

const en_us2_profile_bodyfat_first = /** @type {(inputs: Profile_Bodyfat_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`first measurement`)
};

const pt_br2_profile_bodyfat_first = /** @type {(inputs: Profile_Bodyfat_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`primeira medida`)
};

const es_419_profile_bodyfat_first = /** @type {(inputs: Profile_Bodyfat_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`primera medición`)
};

const pt_pt2_profile_bodyfat_first = /** @type {(inputs: Profile_Bodyfat_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`primeira medição`)
};

const fr_fr2_profile_bodyfat_first = /** @type {(inputs: Profile_Bodyfat_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`première mesure`)
};

const de_de2_profile_bodyfat_first = /** @type {(inputs: Profile_Bodyfat_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`erste Messung`)
};

const it_it2_profile_bodyfat_first = /** @type {(inputs: Profile_Bodyfat_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`prima misurazione`)
};

/**
* | output |
* | --- |
* | "first measurement" |
*
* @param {Profile_Bodyfat_FirstInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_bodyfat_first = /** @type {((inputs?: Profile_Bodyfat_FirstInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Bodyfat_FirstInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_bodyfat_first(inputs)
	if (locale === "es-419") return es_419_profile_bodyfat_first(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_bodyfat_first(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_bodyfat_first(inputs)
	if (locale === "de-DE") return de_de2_profile_bodyfat_first(inputs)
	if (locale === "it-IT") return it_it2_profile_bodyfat_first(inputs)
	return en_us2_profile_bodyfat_first(inputs)
});
export { profile_bodyfat_first as "profile.bodyfat_first" }